import React from 'react';

import PropTypes from 'prop-types';

import { BasicCheckbox, IconCheckbox } from 'core/components';
import { defaultTemplate } from 'core/hoc';

function BasicFieldCheckboxTemplate({ field, onChange, disabled, checkedIconClass, unCheckedIconClass, className}) {
    if(checkedIconClass && unCheckedIconClass){
        return <IconCheckbox 
            {...field.bind()}
            checked={field.value}
            checkedIconClass={checkedIconClass}
            unCheckedIconClass={unCheckedIconClass}
        />;
    }
    else if(onChange){
        return <BasicCheckbox className={'input--check ' + className} {...field.bind({onChange: onChange(field) })} checked={field.value} disabled={disabled} />;
    }else{ 
        return <BasicCheckbox className={'input--check ' + className} {...field.bind()} checked={field.value} disabled={disabled} />;
    }
}

BasicFieldCheckboxTemplate.propTypes = {
    field: PropTypes.any,
    onChange: PropTypes.any,
    disabled: PropTypes.bool,
    checkedIconClass: PropTypes.string,
    unCheckedIconClass: PropTypes.string,
    className: PropTypes.string,
};

export default defaultTemplate(BasicFieldCheckboxTemplate);
